import { Module } from '../../../ts/Module';
import { CheckboxGroupCtrl } from './CheckboxGroupCtrl';

Module.instance().directive('tbCheckboxGroup', <any[]>[
  () => {
    return {
      restrict: 'E',
      transclude: true,
      replace: true,
      template: '<div class="tb-checkbox-group" ng-transclude></div>',
      controller: CheckboxGroupCtrl
    };
  }
]);
